import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Icons from '@olxbr/olx-icons'
import { Button, Text, View, Title } from '@olxbr/design-system'

import Modal from '../../organisms/Modal'
import Recaptcha from '../../atoms/Recaptcha'
import { startTakeout } from '../../../api/takeout'

const recaptchaSiteKey = '6Legz2gUAAAAAH0T1aFbgPvFOVjFHOaKto3GNMMN'

const TitleWrapper = styled(View)`
  margin-bottom: 12px;
`

const SafetyTipWrapper = styled(View)`
  display: flex;
  align-items: center;
  margin-top: 4px;
`

const SafetyTipText = styled(Text)`
  font-size: 12px;
  color: #999999;
  margin-left: 4px;
`

const ButtonWrapper = styled(Button)`
  margin-top: 24px;
  margin-bottom: 8px;
  flex: none;
`

class AccountTakeoutRequestModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      recaptchaReady: false,
      recaptchaVerified: false,
      recaptchaToken: '',
      submitting: false,
    }
  }

  onRecaptchaExpiration = () => this.setState({ recaptchaVerified: false }, this.recaptcha.reset())

  onRecaptchaLoad = () => this.setState({ recaptchaReady: true })

  onRecaptchaVerify = recaptchaToken => {
    if (recaptchaToken) {
      this.setState({ recaptchaToken, recaptchaVerified: true })
    } else {
      this.props.lurker.viewMessageEvt('recaptcha_failed_token')
      this.setState({ recaptchaToken: '' })
      this.recaptcha.reset()
    }
  }

  onRecaptchaError = () => {
    this.props.lurker.viewMessageEvt('recaptcha_error')
    this.setState({
      recaptchaReady: false,
      recaptchaVerified: false,
      recaptchaToken: '',
    })
  }

  onSuccess = () => {
    this.setState({ submitting: false })
    if (this.props.onSuccess) {
      this.props.onSuccess()
    }
  }

  onError = () => {
    if (this.props.onError) {
      this.props.onError()
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    this.setState({ submitting: true })
    startTakeout(this.state.recaptchaToken)
      .then(this.onSuccess)
      .catch(this.onError)
      .finally(() => this.setState({ submitting: false }))
  }

  render() {
    const { recaptchaReady, recaptchaVerified, submitting } = this.state
    const { onClose, open } = this.props
    return (
      <Modal open={open} onClose={onClose}>
        <TitleWrapper>
          <Title>Para continuar, confirme</Title>
        </TitleWrapper>
        <Recaptcha
          ref={e => {
            this.recaptcha = e
          }}
          sitekey={recaptchaSiteKey}
          onLoad={this.onRecaptchaLoad}
          onVerify={this.onRecaptchaVerify}
          onExpire={this.onRecaptchaExpiration}
          onError={this.onRecaptchaError}
        />
        <SafetyTipWrapper>
          <Icons.System.Shield color="#999" width="20" height="13" />
          <SafetyTipText>Isso nos ajuda a manter seus dados protegidos</SafetyTipText>
        </SafetyTipWrapper>
        <ButtonWrapper
          fluid
          size="large"
          disabled={!(recaptchaReady && recaptchaVerified) || submitting}
          isLoading={submitting}
          onClick={this.handleSubmit}
        >
          Solicitar arquivo
        </ButtonWrapper>
      </Modal>
    )
  }
}

AccountTakeoutRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
}

export default AccountTakeoutRequestModal
